import { BusEventWithPayload } from '@grafana/data';

class SceneGridLayoutDragStartEvent extends BusEventWithPayload {
}
SceneGridLayoutDragStartEvent.type = "scene-grid-layout-drag-start";

export { SceneGridLayoutDragStartEvent };
//# sourceMappingURL=types.js.map
